import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, IdentificationCard, CalendarBlank, CurrencyInr, Clock } from "@phosphor-icons/react";
import { PageLoader, Stat } from "../../components/shared";
import { Button } from "../../components/ui/button";
import api, { money } from "../../lib/api";
import { useAutoRefresh } from "../../hooks/useAutoRefresh";
import { RefreshBar } from "../../components/RefreshBar";

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/dashboard").then((r) => setD(r.data));
  const { refreshing, lastUpdated, refresh } = useAutoRefresh(load, []);
  if (!d) return <PageLoader />;

  return (
    <div>
      <RefreshBar refreshing={refreshing} lastUpdated={lastUpdated} onRefresh={refresh} />
      <div className="overline mb-1">Overview</div>
      <h1 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight mb-6">Admin Console</h1>

      {d.pending_approvals > 0 && (
        <div className="mb-6 rounded-xl border border-amber-500/30 bg-amber-500/10 p-4 flex items-center justify-between">
          <span className="inline-flex items-center gap-2 text-sm text-amber-200"><Clock className="text-amber-400" /> <b className="text-amber-100">{d.pending_approvals}</b> organizer(s) awaiting approval</span>
          <Button asChild size="sm" className="rounded-full"><Link to="/admin/organizers">Review now</Link></Button>
        </div>
      )}

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <Stat label="GMV" value={money(d.gmv)} accent />
        <Stat label="Platform Commission" value={money(d.platform_commission)} />
        <Stat label="Bookings" value={d.bookings} />
        <Stat label="Published Events" value={d.published_events} />
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        <Stat label="Customers" value={d.customers} />
        <Stat label="Organizers" value={d.organizers} />
        <Stat label="Pending Approvals" value={d.pending_approvals} />
      </div>
    </div>
  );
}
